export interface AuthProgressState {
  phoneNumber: string;
  emailAddress: string;
  zipCode: string;
  isRegistering: boolean;
  isSignupFromTryPhilo: boolean;
  isLoginFromTryPhilo: boolean;
  isEmailAuthentication: boolean;
  isEmailRegistration: boolean;
  isEduAuthentication: boolean;
  isEduWithMobile: boolean;
  restartLinkPath: string;
  message: string;
}

const initialState: AuthProgressState = {
  phoneNumber: '',
  emailAddress: '',
  zipCode: '',
  isRegistering: false,
  isSignupFromTryPhilo: false,
  isLoginFromTryPhilo: false,
  isEmailAuthentication: false,
  isEmailRegistration: false,
  isEduAuthentication: false,
  isEduWithMobile: false,
  restartLinkPath: '',
  message: '',
};

export default initialState;
